import globalScope from 'core/globalScope';

function trackerPostuler() {
  if (globalScope.window._abtasty) {
    globalScope.window._abtasty = globalScope.window._abtasty || [];
    globalScope.window._abtasty.push(['transaction', 'CANDIDATURE']);
  } else {
    console.warn("globalScope.window._abtasty not found")
  }
}

function trackerDepotCV() {
  if (globalScope.window._abtasty) {
    globalScope.window._abtasty = globalScope.window._abtasty || [];
    globalScope.window._abtasty.push(['transaction', 'DEPOT_CV']);
  } else {
    console.warn("globalScope.window._abtasty not found")
  }
}

function trackerCreationAlerte() {
  if (globalScope.window._abtasty) {
    globalScope.window._abtasty = globalScope.window._abtasty || [];
    globalScope.window._abtasty.push(['transaction', 'ALERTE_MAIL']);
  } else {
    console.warn("globalScope.window._abtasty not found")
  }
}

export { trackerPostuler, trackerDepotCV, trackerCreationAlerte };
